import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { checkUserAuthAndTerms } from '~/shared/auth/auth-utils';
import { listDevicesQuery } from '~/shared/api/listDevices.queries';
import { DevicesListModel } from '~/shared/models/devicesList/DevicesListModel';
import { authService } from '~/services/auth/auth-service.ts';

export type DevicesListPageLoaderData = DevicesListModel;

export const devicesListPageLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await authService.initialized;

    if (!authService.isSignedIn) {
      return null;
    }

    await checkUserAuthAndTerms(queryClient, request);

    return await queryClient.ensureQueryData(listDevicesQuery);
  };
